/* eslint-disable max-len */
import React from 'react'
import Svg, { Path } from 'react-native-svg'

interface SuccessIconProps {
  color: string
}

const SuccessIcon = (props: SuccessIconProps) => {
  const { color } = props
  return (
    <Svg viewBox="0 0 48 48" fill="none">
      <Path
        d="M47.083 23.597a23.487 23.487 0 01-46.973 0c0-1.214.095-2.425.285-3.624a1.682 1.682 0 113.355.235c.009.1.009.201 0 .302a18.237 18.237 0 00-.285 3.087A20.13 20.13 0 1023.596 3.465a18.253 18.253 0 00-3.086.252 1.701 1.701 0 01-.554-3.355 23.18 23.18 0 013.64-.252 23.488 23.488 0 0123.487 23.487zm-32.043-6.56a5.67 5.67 0 00-4.58 3.204 1.676 1.676 0 00.755 2.248c.232.126.492.19.755.185a1.678 1.678 0 001.493-.923 2.348 2.348 0 013.976-.369l.453.621a1.679 1.679 0 002.685-2.013l-.454-.621a5.688 5.688 0 00-5.083-2.332zm7.684 13.623a5.62 5.62 0 00-3.12-4.58 1.68 1.68 0 00-1.51 3.003 2.262 2.262 0 011.291 1.878 2.33 2.33 0 01-.922 2.08l-.621.454a1.676 1.676 0 001.007 3.02c.363 0 .716-.118 1.006-.336l.621-.453a5.864 5.864 0 001.51-1.678l12.75 2.299c.25.024.504.024.755 0a4.312 4.312 0 004.328-4.362 4.327 4.327 0 00-4.329-4.312h-1.677a1.679 1.679 0 000 3.356h1.677a.974.974 0 01.621 1.677.94.94 0 01-.788.218l-12.6-2.281v.017zm6.576-8.741l.453-.62a2.349 2.349 0 013.976.368 1.676 1.676 0 001.493.923c.264.005.524-.059.755-.185a1.676 1.676 0 00.755-2.164 5.72 5.72 0 00-9.663-.872l-.453.62a1.679 1.679 0 002.684 1.93zM.11 2.273A1.677 1.677 0 012.272.11l14.613 4.43a1.678 1.678 0 011.158 1.207c.14.574-.032 1.18-.453 1.594L7.34 17.506c-.314.32-.743.502-1.191.504h-.403a1.679 1.679 0 01-1.208-1.124L.11 2.273zm4.11 2.014l2.734 8.874 6.207-6.207L4.22 4.287z"
        fill={color}
      />
    </Svg>
  )
}

export default SuccessIcon
